import React, { Suspense } from 'react'
import { BrowserRouter, Navigate, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'

import Preloader from './components/Preloader'
import GeneralPath from './GeneralPath'
import Homepage from './pages/General/Homepage'
import PropertyDetails from './pages/General/PropertyDetails'
import Properties from './pages/General/Properties'
import About from './pages/General/About'
import Contact from './pages/General/Contact'
import PropertyTypes from './pages/General/PropertyTypes'

import Signup from './pages/General/Signup'
import Login from './pages/General/Login'
import AdminPath from './AdminPath'
import DashboardHome from './pages/Admin/DashboardHome'
// import DashboardSingleProperty from './pages/Admin/DashboardSingleProperty'
import DashboardProperty from './pages/Admin/DashboardProperty'
import DashboardContact from './pages/Admin/DashboardContact'
import DashboardInspection from './pages/Admin/DashboardInspection'

const App = () => {
	return (
		<>
			<BrowserRouter>
				<Suspense fallback={<Preloader />}>
					<Routes>
						{/* ------------------------------ genral routes  ---------------------------------- */}
						<Route path='/' element={<Navigate replace to='/home' />} />
						<Route path='/' element={<GeneralPath />}>
							<Route path='home' element={<Homepage />} />
							<Route exact path='about-us' element={<About />} />
							<Route exact path='contact-us' element={<Contact />} />
							<Route exact path='properties' element={<Properties />} />
							<Route
								exact
								path='properties/:slug'
								element={<PropertyTypes />}
							/>
							<Route
								exact
								path='properties/:slug/:id'
								element={<PropertyDetails />}
							/>
							<Route exact path='showel/signup' element={<Signup />} />
							<Route exact path='showel/login' element={<Login />} />
						</Route>
						{/* ------------------------------------------------------------------------------------  */}

						{/* --------------------------------------- admin routes ---------------------------------- */}
						<Route
							path='admin/dashboard'
							element={<Navigate replace to='/admin/dashboard/home' />}
						/>
						<Route path='/admin/dashboard' element={<AdminPath />}>
							<Route path='home' element={<DashboardHome />} />
							<Route path='properties' element={<DashboardProperty />} />
							<Route path='contact-entries' element={<DashboardContact />} />
							<Route
								exact
								path='inspection-entries'
								element={<DashboardInspection />}
							/>
							{/* <Route
								exact
								path='properties/:slug'
								element={<DashboardSingleProperty />}
							/> */}
						</Route>
						{/* ------------------------------------------------------------------------------------------  */}
					</Routes>
				</Suspense>
			</BrowserRouter>
			<Toaster />
		</>
	)
}

export default App
